"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonErrors_de_de = void 0;
function commonErrors_de_de() {
    return {
        "errors.notfound": "Nicht gefunden",
        "errors.nodata": "Keine Daten vorhanden",
        "errors.generic": "Es ist ein unerwarteter Fehler aufgetreten",
        "errors.tryagainlater": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es später noch einmal.",
        "errors.invalidmail": "Bitte geben Sie eine gültige E-Mail Adresse ein (z.B. test@gmail.com)",
        "errors.invalidphonenumber": "Bitte geben Sie eine gültige Telefonnummer ein (z.B. +49896121247)",
        "errors.invalidurl": "Bitte geben Sie eine gültige URL ein",
        "errors.http.400": "Die Anfrage konnte nicht verarbeitet werden",
        "errors.http.401": "Sie sind nicht eingeloggt",
        "errors.http.403": "Kein Zugriff auf diese Resource",
        "errors.http.404": "Die angefragte Resource existiert nicht",
        "errors.http.409": "Die Resource existiert bereits",
        "errors.http.500": "Da ging was schief",
        "errors.http.503": "Der Dienst ist im Moment nicht verfügbar",
        "errors.unreachable.title": "Fehler",
        "errors.unreachable.message": "Das System ist momentan nicht erreichbar, bitte versuchen Sie es in wenigen Augenblicken erneut!",
        "errors.access.nottheowner": "Sie sind nicht der Besitzer dieser Resource",
        "errors.validations.validating_field": "Feld",
        "errors.validations.validation_failed_message": "Bei der Validierung Ihrer Eingaben sind Fehler aufgetreten!",
        "errors.validations.required": "erforderlich",
        "errors.validations.isalpha": "nur Kleinbuchstaben (a-z) sind erlaubt",
        "errors.validations.isemail": "muss gültige E-Mail sein",
        "errors.validations.islowercase": "nur Kleinbuchstaben (a-z) sind erlaubt",
        "errors.validations.isurlconform": "Maximal 45 Zeichen. Alle Zeichen müssen URL konform sein (a-Z 0-9 _\\-~)",
        "errors.validations.length": "muss mindestens 3 Buchstaben enthalten",
        "errors.validations.minlength": "muss eine Mindestlänge von ${requiredLength} Zeichen haben",
        "errors.validations.maxlength": "darf nicht länger als ${maxLength} Zeichen sein",
        "errors.validations.min": "muss mindestens ${min} oder größer sein",
        "errors.validations.max": "darf nicht größer als ${max} sein",
        "errors.validations.minitems": "muss mindestens ${min} Elemente enthalten",
        "errors.validations.maxitems": "darf höchstens ${max} Elemente enthalten",
        "errors.validations.isstring": "muss eine Zeichenkette sein",
        "errors.validations.isint": "muss eine Zahl sein",
        "errors.validations.isobject": "muss ein JavaScript Objekt sein",
        "errors.validations.isjsonschema7": "muss ein JSONSchema7 sein",
        "errors.validations.matches": "muss dem Muster entsprechen",
        "errors.validations.isdefined": "muss definiert sein",
        "errors.validations.pattern": "muss diesem Muster entsprechen: ${requiredPattern}",
        "errors.validations.iconerror": "muss ein valides icon sein",
        "errors.validations.invalidvalue": "muss einem der vorgeschlagenen Werte entsprechen",
        "errors.validations.enum": "muss einem dieser Werte entsprechen: ${enumValues}",
        "errors.validations.type": "muss vom Typ ${type} sein",
        "errors.user.email_already_exists": "Diese E-Mail ist bereits registriert",
        "errors.user.invalid_password_uppercasemissing": "Ungültiges Passwort: Großbuchstabe fehlt",
        "errors.user.invalid_password_lowercasemissing": "Ungültiges Passwort: Kleinbuchstabe fehlt",
        "errors.user.invalid_password_notatleast8characterslong": "Ungültiges Passwort: Bitte mindestens 8 Zeichen eingeben",
        "errors.user.invalid_password_nospecialcharacter": "Ungültiges Passwort: Bitte geben Sie ein Sonderzeichen wie ! ? # oder Leerzeichen ein",
        "errors.user.token_required": "Keinen Token erhalten",
        "errors.user.invalid_password": "Falsches Passwort",
        "errors.user.user_not_found": "Benutzer nicht gefunden",
        "errors.user.invalid_token": "Ungültiges Token",
        "errors.user.invalidjsonprofileschema": "Schema des Benutzerprofils ist nicht in validem JSON Format",
        "errors.user.notmatchingprofileschema": "Benutzerprofil entspricht nicht dem definierten Schema",
        "errors.user.noprofileschema": "Kein aktuelles JSON formatiertes Benutzerprofilschema gefunden",
        "errors.user.notalloldkeyspresentinschema": "Im neuen Schema sind nicht alle Werte des alten Schemas enthalten",
        "errors.user.newandoldtypenotmatching": "Alle vorhandenen Datentypen müssen mit den neuen übereinstimmen",
        "errors.user.creationnotallowed": "Erstellung neuer Benutzer ist nicht erlaubt.",
        "errors.invitation.missingrole": "Eine Einladung muss mindestens eine Rolle enthalten.",
        "errors.invitation.notenant": "Kein Tenant gefunden für ID: ",
        "errors.invitation.notinvitable": "Einladungen können nur für Projekte oder Firmen erstellt werden.",
        "errors.verify.email.invalid_token": "Token ist nicht valide",
        "errors.verify.email.incorrect_token": "Token ist fehlerhaft",
        "errors.verify.email.email_not_found": "Email konnte nicht gefunden werden",
        "errors.verify.email.could_not_send": "Email-Bestätigung konnte nicht versendet werden",
        "errors.file.unsplash.notoken": "Der Reseller hat keinen API Key für Unsplash.com gesetzt.",
        "errors.file.unsplash.invalidtoken": "Der Token für Unsplash.com ist nicht valide.",
        "errors.file.unsplash.limitexceeded": "Anfragelimite von Unsplash.com wurde überschritten.",
        "errors.file.unsplash.generalerror": "Bei der Anfrage auf Unsplash.com ist ein Fehler aufgetreten.",
        "errors.note.noservicetoken": "ServiceTokens können nicht zum Lesen oder Verändern von Notizen verwendent werden.",
        "errors.note.usernotfound": "Zu dieser Notiz konnte kein Benutzer gefunden werden.",
        "errors.note.onlyeditpersonal": "Es können nur persönliche Notizen bearbeitet werden.",
        "errors.note.onlyaccesspersonal": "Persönliche Notizen von Anderen können nicht betrachtet werden.",
        "errors.note.notargetidchange": "Die TargetId kann nicht verändert oder gelöscht werden."
    };
}
exports.commonErrors_de_de = commonErrors_de_de;
